var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/youtube_circular.a4925c0e.png","uri@2x": __webpack_public_path__ + "static/media/youtube_circular.044754ff.png","uri@3x": __webpack_public_path__ + "static/media/youtube_circular.5b42a276.png",
    width: 28,
    height: 28
});